import React, {FC} from 'react';
import kennels from '../../assets/images/icon-page/kennals.png';


const KennelsIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Kennels Icon'}) => {
    return (
        <img
            src={kennels}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default KennelsIcon;
